import React from 'react'
import { useTranslation } from 'react-i18next'
import { trackEvent } from '@fs/zion-analytics'
import { getPersonName, useSlsStateContext } from '@fs/zion-sls'
import { ControlSplit } from '@fs/zion-icon'
import { Paragraph, Button, DataBlock, H3 } from '@fs/zion-ui'
import FieldWrapper from '../../ui/FieldWrapper'
import RowWrapper from '../../ui/RowWrapper'
import Subsection from './Subsection'
import NoDataAddedMessage from './NoDataAddedMessage'
import FieldDisplay from './FieldDisplay'
import InfoSectionHeader from './InfoSectionHeader'
import { useR2DispatchContext } from '../../../../../providers/r2Provider/R2Context'
import { useOverlayContext } from '../../../../../../shared/providers/overlayContextProvider/OverlayContext'
import BottomSheetDivider from './BottomSheetDivider'

const RelationshipSection = ({
  relationshipFields,
  isRestrictedRelationshipField,
  disableEdit,
  othersOnThisRecord,
}) => {
  const { openOverlay, infoSheetOverlay } = useOverlayContext()
  const [t] = useTranslation()
  const zionSlsState = useSlsStateContext()
  const dispatch = useR2DispatchContext()

  return (
    <>
      <InfoSectionHeader
        element={{ label: t('view-index.relationships.title', 'Relationships'), elementType: 'relationships' }}
        disabled={isRestrictedRelationshipField || disableEdit}
        onEditClick={() => {
          openOverlay('editRelationships')
          trackEvent({
            event_name: 'click_action',
            link_name: `Edit: Relationships: Open`,
          })
        }}
      />
      {relationshipFields?.length > 0 && (
        <Subsection>
          <RowWrapper>
            {relationshipFields.map(
              (field) => field && <FieldDisplay key={field.id} field={field} value={field.value} />
            )}
          </RowWrapper>
        </Subsection>
      )}
      {relationshipFields?.length === 0 && (
        <Subsection>
          <FieldWrapper>
            <NoDataAddedMessage />
          </FieldWrapper>
        </Subsection>
      )}
      {othersOnThisRecord.length > 0 && (
        <>
          <FieldWrapper>
            <H3 size="H6">{t('view-index.others-on-this-record', 'Others on This Record')}</H3>
          </FieldWrapper>
          {othersOnThisRecord.map((page) => (
            <Subsection key={page.pageNumber}>
              {page.partitionKey !== zionSlsState.currentImageArk && (
                <>
                  <Paragraph size="xs">
                    {t('relationships.names-on-page-n.label', 'Names on Page {pageNumber}', {
                      pageNumber: page.pageNumber,
                    })}
                  </Paragraph>
                  <Button
                    Icon={ControlSplit}
                    emphasis="medium"
                    onClick={() =>
                      dispatch({
                        type: 'OPEN_SPLIT_SCREEN_TO_PAGE',
                        value: page.pageNumber,
                      })
                    }
                  >
                    {t('relationships.view-in-context', 'View in Context')}
                  </Button>
                </>
              )}
              <RowWrapper style={{ paddingInlineStart: '10PX' }}>
                {page.persons.map((person) => (
                  <FieldWrapper key={person.id}>
                    <DataBlock inline data={getPersonName({ person })} heading="" />
                  </FieldWrapper>
                ))}
              </RowWrapper>
            </Subsection>
          ))}
        </>
      )}
      {infoSheetOverlay?.isBottomSheet && <BottomSheetDivider />}
    </>
  )
}

export default RelationshipSection
